"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _emotion = require("../../utils/emotion");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CodeComponent = function CodeComponent(props) {
  var children = props.children,
    className = props.className;
  var rootClass = (0, _useCss["default"])(function (theme) {
    return _objectSpread(_objectSpread({
      margin: theme.size(1, 0),
      padding: theme.size(1, 2),
      borderRadius: theme.size(0.5),
      maxHeight: 351,
      overflow: 'hidden',
      overflowY: 'auto',
      backgroundColor: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.high, 0.25),
      color: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.low, 0.05)
    }, theme.scroll({
      size: 10
    })), theme.text({
      variant: 'code',
      size: 'small'
    }));
  });
  var content = (0, _react.useMemo)(function () {
    if (typeof children !== 'string') {
      return null;
    }
    var strings = children.split('\n');
    var offset = strings.reduce(function (acc, str) {
      if (!str.trim()) {
        return acc;
      }
      var currentOffset = str.search(/\S/);
      return Math.min(acc, currentOffset);
    }, Infinity);
    if (strings.length > 0 && !strings[strings.length - 1].trim()) {
      strings.pop();
    }
    if (strings.length > 0 && !strings[0].trim()) {
      strings.shift();
    }
    return strings.map(function (str) {
      if (!str.trim()) {
        return str;
      }
      return str.slice(offset);
    }).join('\n');
  }, [children]);
  if (!content) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("pre", {
    className: (0, _emotion.cx)(rootClass, className),
    children: content
  });
};
var _default = CodeComponent;
exports["default"] = _default;